import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "utils/api";
import { floorPlanComparisonKeys } from "./floorPlanComparisonKeys";
import type {
  FloorPlanComparisonResponse,
  UseFloorPlanComparisonArgs,
  UseFloorPlanComparisonResult,
} from "./types";

export const useFloorPlanComparison = ({
  baseFloorPlanId,
}: UseFloorPlanComparisonArgs): UseFloorPlanComparisonResult => {
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: floorPlanComparisonKeys.detail(baseFloorPlanId),
    queryFn: (): Promise<FloorPlanComparisonResponse> =>
      api.getQuantitySurveyorFloorPlanComparison(baseFloorPlanId),
  });

  const { mutateAsync: saveComparedPlan } = useMutation({
    mutationFn: (
      comparedFloorPlanId: number,
    ): Promise<FloorPlanComparisonResponse> =>
      api.setQuantitySurveyorFloorPlanComparison(
        baseFloorPlanId,
        comparedFloorPlanId,
      ),
    onSuccess: (_data, comparedFloorPlanId) => {
      queryClient.setQueryData<FloorPlanComparisonResponse>(
        floorPlanComparisonKeys.detail(baseFloorPlanId),
        { comparedFloorPlanId },
      );
    },
  });

  return {
    rememberedComparedPlanId: data?.comparedFloorPlanId ?? null,
    saveComparedPlan,
  };
};
